/**
 * ESM wrapper around seoCategories.json (the auto-generated data — see
 * scripts/seo/generate-seo-categories.js). Kept as plain JSON, not a `.js`
 * file with `export const`, so it can be `require()`-d as-is by the
 * CommonJS server code (server/api/jobs/seoEligibility.job.js) without any
 * build step, while still importing cleanly here for the client bundle.
 */
import seoCategoriesData from './seoCategories.json';

export const seoCategories = seoCategoriesData;

export default seoCategories;
